import { api } from '@api'
import { Supplier } from '@types'

export interface Form {
  supplierId: number
  category?: number
  enabledForAlgorithm?: boolean
}

export interface SupplierWithPassword extends Supplier {
  password?: string
}

interface CreateSupplierResponse {
  result: Supplier
}

const createSupplier = async (payload: SupplierWithPassword) => {
  const response = await api.post<CreateSupplierResponse>('/suppliers', { supplier: payload })

  return response.data.result
}

export { createSupplier }
